<template>
  <form :method="method" :action="action">
    <validation-observer ref="form" v-slot="{ passes, invalid }">
      <slot :form="form" :invalid="invalid" />
    </validation-observer>
  </form>
</template>
<script>
export default {
  props: {
    method: {
      type: String,
      default: 'POST'
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      form: {}
    }
  }
}
</script>
